import React, { useState } from "react";
import styled from "@emotion/styled";
import { rgba } from "polished";
//import { NavLink } from "react-router-dom";

import { fetchApi } from "@/utils/fetchApi";
import { CartProvider, useCart } from "./CartProvider";
import CartContents from "./CartContents";

import {
  Box,
  Button,
  Container,
  CardActions,
  CardContent,
  Card as MuiCard,
  CardHeader as MuiCardHeader,
  Grid,
  Typography,
} from "@mui/material";
import { StarBorder as StarIcon } from "@mui/icons-material";
import { spacing } from "@mui/system";
//import { ArrowForward as ArrowForwardIcon } from "@mui/icons-material";

const Wrapper = styled.div`
  ${spacing};
  background: ${(props) => props.theme.palette.background.paper};
  text-align: center;
`;

const TypographyOverline = styled(Typography)`
  text-transform: uppercase;
  color: ${(props) => props.theme.palette.primary.main};
  font-weight: ${(props) => props.theme.typography.fontWeightMedium};
`;

const Card = styled(MuiCard)(spacing);

const CardHeader = styled(MuiCardHeader)(spacing);

const Price = styled.div`
  text-align: center;
  padding-bottom: ${(props) => props.theme.spacing(3)};
`;

//const ArrowForward = styled(ArrowForwardIcon)`
//  margin-left: ${(props) => props.theme.spacing(2)};
//`;

const AddToCartButton = ({ item }) => {
  const { addToCart } = useCart();

  return (
    <Button
      onClick={() => {
        console.log("add to cart");
        addToCart(item);
      }}
    >
      Add to Cart: {item.name}
    </Button>
  );
};

function Cart() {
  return (
    <Wrapper py={20}>
      <Container>
        <Grid container justifyContent="center">
          <Grid item xs={12}>
            <Typography>Shopping Cart</Typography>

            <CartProvider>
              <AddToCartButton
                item={{
                  id: "prod_PWrwkwCIT8oC5q",
                  object: "product",
                  active: true,
                  attributes: [],
                  created: 1707462558,
                  default_price: "price_1OhoD4GZSVv8nX6HbrEp8bWy",
                  description: "3-day trial subscription",
                  features: [],
                  images: [],
                  livemode: false,
                  metadata: {},
                  name: "3-Day Trial Subscription",
                  package_dimensions: null,
                  shippable: null,
                  statement_descriptor: null,
                  tax_code: "txcd_10000000",
                  type: "service",
                  unit_label: null,
                  updated: 1707462558,
                  url: null,
                }}
              />
              <AddToCartButton
                item={{
                  id: "prod_PWrtKciufcmcmu",
                  object: "product",
                  active: true,
                  attributes: [],
                  created: 1707462343,
                  default_price: "price_1Oho9cGZSVv8nX6HXbaxEX6D",
                  description: null,
                  features: [],
                  images: [],
                  livemode: false,
                  metadata: {},
                  name: "Annual Subscription",
                  package_dimensions: null,
                  shippable: null,
                  statement_descriptor: null,
                  tax_code: "txcd_10000000",
                  type: "service",
                  unit_label: null,
                  updated: 1707462344,
                  url: null,
                }}
              />
              <AddToCartButton
                item={{
                  id: "prod_PWMm3DPiSb4DSh",
                  object: "product",
                  active: true,
                  attributes: [],
                  created: 1707346637,
                  default_price: null,
                  description: "$300/month subscription",
                  features: [],
                  images: [],
                  livemode: false,
                  metadata: {},
                  name: "Basic Subscription",
                  package_dimensions: null,
                  shippable: null,
                  statement_descriptor: null,
                  tax_code: "txcd_10000000",
                  type: "service",
                  unit_label: null,
                  updated: 1707462222,
                  url: null,
                }}
              />
              <CartContents />
            </CartProvider>
          </Grid>
        </Grid>
      </Container>
    </Wrapper>
  );
}

export default Cart;
